/** A raised block with an optional title row. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./Card.css";

export interface CardProps {
  readonly title?: ReactNode;
  readonly action?: ReactNode;
  readonly padding?: "default" | "none";
  readonly "aria-label"?: string;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function Card({
  title,
  action,
  padding = "default",
  "aria-label": ariaLabel,
  className,
  style,
  children,
}: CardProps) {
  const headed = title !== undefined || action !== undefined;
  return (
    <section
      className={cn("al-card", `al-card-pad-${padding}`, className)}
      style={style}
      aria-label={ariaLabel}
    >
      {headed ? (
        <header className="al-card-head">
          {title !== undefined ? <h2 className="al-card-title">{title}</h2> : <span />}
          {action !== undefined ? <div className="al-card-action">{action}</div> : null}
        </header>
      ) : null}
      <div className="al-card-body">{children}</div>
    </section>
  );
}
